import {HttpBackend, HttpClient} from '@angular/common/http';
import {TranslateLoader} from '@ngx-translate/core';
import {catchError, forkJoin, Observable, of} from 'rxjs';
import {Injectable} from '@angular/core';
import {map} from 'rxjs/operators';
import {isPlainObject, merge, set} from 'lodash-es';

@Injectable()
export class CustomTranslateLoader implements TranslateLoader {

  private http: HttpClient;

    constructor(private handler: HttpBackend) {
      this.http = new HttpClient(handler);
    }

  flattenObject(obj: Object, parentKey = '', result = {}) {
    if (!isPlainObject(obj)) {
      console.warn('Provided object is not a plain object:', obj);
      return result;
    }

    for (const [key, value] of Object.entries(obj)) {
      const fullKey = parentKey ? `${parentKey}.${key}` : key;
      if (isPlainObject(value)) {
        this.flattenObject(value, fullKey, result);
      } else {
        result[fullKey] = value;
      }
    }
    return result;
  }

  unflattenObject(obj: Object) {
    const result = {};
    for (const [key, value] of Object.entries(obj)) {
      set(result, key, value);
    }
    return result;
  }

  getTranslation(lang: string): Observable<Object> {
    console.debug(`Loading translations for language: ${lang}`);
    return forkJoin([
      this.http.get(location.pathname + `assets/i18n/${lang}.json`),
      this.http.get(location.pathname + `assets/i18n/${lang}_client.json`).pipe(catchError(() => {
        console.warn(`Client translations for language ${lang} not found`);
        return of({});
      })),
    ]).pipe(
      map(([common, client]) => {
        const flattenedCommon = this.flattenObject(common);
        const flattenedClient = this.flattenObject(client);
        return this.unflattenObject(merge({}, flattenedCommon, flattenedClient));
      }),
    );
  }
}
